export default class Navbar {
    static init(): void {
        this.navbarInit();
    }

    static navbarInit(): void {
        class MobileMenu {
            private toggle: HTMLElement | null;
            private menu: HTMLElement | null;
            private items: NodeListOf<HTMLElement>;
            private readonly breakpoint: number = 992;

            constructor() {
                this.toggle = document.querySelector('.base-nav__toggle');
                this.menu = document.querySelector('.base-nav-mobile');
                this.items = document.querySelectorAll('.base-nav-mobile__item');

                this.init();
            }

            private init(): void {
                if (!this.toggle || !this.menu) return;

                // Toggle menu při kliknutí
                this.toggle.addEventListener('click', () => this.toggleMenu());

                // Zavření menu při kliknutí na item
                this.items.forEach((item) => {
                    item.addEventListener('click', () => this.closeMenu());
                });

                // Zavření menu při resize nad breakpoint
                window.addEventListener('resize', () => this.handleResize());
            }

            private toggleMenu(): void {
                this.toggle?.classList.toggle('is-active');
                this.menu?.classList.toggle('is-open');
            }

            private closeMenu(): void {
                this.toggle?.classList.remove('is-active');
                this.menu?.classList.remove('is-open');
            }

            private handleResize(): void {
                if (window.innerWidth > this.breakpoint) {
                    this.closeMenu();
                }
            }
        }

        // Inicializace
        new MobileMenu();

        const nav = document.querySelector('.base-nav');
        if (nav) {
            const onScroll = () => {
                nav.classList.toggle('base-nav--not-top', window.scrollY > 0);
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }
    }
}
